import palette from "../../../styles/palette";

export default {

    leftButton: {
        position: "absolute",
        left: 5,
        bottom: 5,
    } as React.CSSProperties,
    rightButton: {
        position: "absolute",
        right: 5,
        bottom: 5,
    } as React.CSSProperties,
    editButtonIcon: {
        color: palette.active.primary
    } as React.CSSProperties,
    commitButtonIcon: {
        color: palette.states.success
    } as React.CSSProperties,
    cancelButtonIcon: {
        color: palette.states.danager
    } as React.CSSProperties,
}